import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import CookieConsent from "@/components/CookieConsent";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { initConsentOnLoad } from "@/lib/consent";

export default function Layout({ children }) {
  const { pathname } = useLocation();

  // Re-apply any previously stored cookie consent once on app load.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    initConsentOnLoad();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // GA4 SPA page-view tracking (gtag is injected in public/index.html)
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <FloatingActions />
      <CookieConsent />
    </div>
  );
}
